<template>
    <div class="white-container">
        <h2 class="section-title">{{$t("donate.LBL_PAGE_HEADER")}}</h2>
        <p v-html="$t('donate.LBL_PAGE_DESCRIPTION')"></p>
        <div class="donate-container">
            <div class="form-wrapper">
                <div class="payment-value">
                    <div class="item" v-for="(donate_sum,index) in donates" :class="{'selected':donate_value==donate_sum}" @click="donate_value=donate_sum">
                        <span class="price" v-html="formatPrice(donate_sum,'EUR')"></span>
                    </div>
                </div>
                <div class="payment-methods">
                    <div class="item" @click="checkout('maib')">
                        <span>{{$t("shop.LBL_PAYMENT_METHOD_CARD")}}</span>
                    </div>
                    <div class="item" @click="checkout('paypal')">
                        <span>{{$t("shop.LBL_PAYMENT_METHOD_PAYPAL")}}</span>
                    </div>
                </div>
                <p class="helper" v-html="$t('donate.LBL_TEXT_FORM_HELPER')"></p>
            </div>
            <div class="helper">
                <div class="block-title section-title">{{$t("donate.LBL_CONTENT_BLOCK1_HEADER")}}</div>
                <ul>
                    <li v-for="(message,i) in $t('donate.LBL_CONTENT_BLOCK1_LIST')">{{message}}</li>
                </ul>
                <div class="block-title section-title">{{$t("donate.LBL_CONTENT_BLOCK2_HEADER")}}</div>
                <p v-html="$t('donate.LBL_CONTENT_BLOCK2_CONTENT')"></p>
            </div>
        </div>
        <OrderErrorPopup
        :show="order_error"
        :description="order_description"
        v-on:closeEvent="OrderErrorPopupCloseEvent"
        ></OrderErrorPopup>
    </div>
</template>
<style lang="scss">
    div.white-container{
        padding: 24px;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        margin-bottom: 2.3rem;
        background: #FFFFFF;
        border-radius: 20px;
    }
    .section-title{
        font-family: FuturaPT;
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 26px;
        margin-bottom: 6px;
        color: #0B1022;
    }
    p,ul{
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 23px;
        color: #595959;
        letter-spacing:normal;
        font-family: FuturaPT;
        li{
            font-size:16px;
            line-height: 21px;
        }
    }
    .donate-container{
        display:flex;
        flex-wrap:nowrap;
        flex-direction:row;
        margin-top: 54px;

        .form-wrapper{
            min-width:50%;
            padding-right:4rem;
            .payment-value{
                display: grid;
                grid-template-columns: repeat(4,1fr);
                grid-gap:8px;
                margin-bottom: 16px;
                .item{
                    background: #F0F3F8;
                    border-radius: 10px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 14px;
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: bold;
                    letter-spacing: 0.5px;
                    font-family: FuturaPT;
                    &.selected{
                        background:#05C46B;
                        color:#fff;
                    }
                    span.price{
                        margin-right:0.2px;
                    }
                    &:hover{
                        box-shadow: 0px 2px 4px #C8C8C8;
                    }
                }
            }
            .payment-methods{
                display: grid;
                grid-template-columns: repeat(2,1fr);
                grid-gap:8px;
                margin-bottom: 32px;
                .item{
                    background: #CF0920;
                    border-radius: 24px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 9px;
                    font-size: 16px;
                    font-family: FuturaPT;
                    letter-spacing: 0.5px;
                    font-weight: 500;
                    color:#fff;
                    &.selected{
                        background:#05C46B;
                        color:#fff;
                    }
                    &:hover{
                        box-shadow: 0px 2px 4px #C8C8C8;
                    }
                }
            }
            p{
                color: #B6B7BD;
                font-size: 1rem;
                font-weight: 100;
                &.helper{
                    font-size: 14px;
                    line-height: 18px;
                    color: #B6B7BD;
                }
            }
        }
        .helper{

        }

        .block-title{
            margin-top:32px;
            margin-bottom: 16px;
            &:first-child{
                margin-top:0px;
            }
        }
        ul li{
            margin-bottom: 8px;
            padding-left: 11px;
            position: relative;
            &:before{
                content: "";
                display: inline-block;
                width: 4px;
                height: 4px;
                background: #05C46B;
                border-radius: 100%;
                vertical-align: super;
                position: absolute;
                left: 0px;
                top: 9px;
            }
        }
        p{
            font-size:16px;
            line-height: 21px;
        }
    }
    @media(max-width:700px){
        .section-title{
            margin-bottom: 15px;
        }
        .donate-container{
            margin-top:24px;
            display:block;
            .form-wrapper{
                padding-right: 0px;
                margin-bottom: 32px;
                .payment-methods{
                    grid-template-columns: repeat(1,1fr);
                    margin-bottom: 16px;
                }
            }
            .helper .block-title{
                font-size:18px;
                line-height: 120%;
            }
        }
    }
</style>
<script>
    import store from '@/store';
    import {decodeHtml,formatPrice,rest} from '@/utils/utils';
    import { mapGetters, mapActions } from 'vuex';
    import OrderErrorPopup from './popups/OrderErrorPopup';

    export default {
        name:'Donate',
        components:{
            OrderErrorPopup
        },
        data:function(){
            return{
                donate_value:5,
                donates:[5,10,15,20],
                rate:0,
                order_error:false,
                order_description:"",
            }
        },
        mounted(){
            store.commit('loading/is', true);
            rest.call("get_currency_value",{
                    "from":this.user.currency,
                    "to":"MDL",
                },"GET").then((response)=>{
                    if(response){
                        this.rate = response.rate;
                    }
                    store.commit('loading/is', false);
                }).catch((error)=>{
                    store.commit('loading/is', false);
                });
        },
        computed:{
            ...mapGetters({
                user: 'user/get',
            }),
        },
        methods:{
            checkout(method){
                store.commit('loading/is', true);
                rest.call("make_donate",{
                    "total":this.donate_value,
                    "method":method,
                    "currency":this.user.currency,
                    "rate":this.rate,
                },"GET").then((response)=>{
                    store.commit('loading/is', false);
                    if(response.status && response.redirect){
                        window.location.href = decodeHtml(response.redirect);
                    }
                    if(response.status && response.status == "error"){
                        this.order_error = true;
                        this.order_description = null;
                    }
                }).catch((error)=>{
                    store.commit('loading/is', false);
                });
            },
            OrderErrorPopupCloseEvent(){
                this.order_error=false;
            },
            formatPrice(value,currency=null){
                currency = currency?currency:this.user.currency;
                return formatPrice(value,currency);
            },
        },
        watch:{},
    }
</script>